import _ from 'lodash';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Button, Col, Row } from 'antd';
import { makeObservable } from 'mobx';
import WorkOrderLineItemContext from '../LineItems/WorkOrderLineItemContext';
import WorkOrderLineItemPartsItem from './WOLineItemPartsItem';
import { PlusCircleOutlined } from '@ant-design/icons';

class WorkOrderLineItemParts extends Component {
  static contextType = WorkOrderLineItemContext;

  static propTypes = {
    childRef: PropTypes.func,
    onUpdateLineTotal: PropTypes.func,
    title: PropTypes.string,
    description: PropTypes.string,
    items: PropTypes.any,
    onAddItem: PropTypes.func,
    onRemoveItem: PropTypes.func,
    onAddNewPart: PropTypes.func.isRequired,
    shopParts: PropTypes.array,
    onUpdateLocalItem: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
  };

  constructor() {
    super();
    makeObservable(this);
  }

  state = {};

  partsItemsRefs = {};

  componentDidMount() {
    const { childRef } = this.props;
    childRef(this);
  }

  onRemoveItem = (event, itemKey) => {
    if (this.props.onRemoveItem) {
      this.props.onRemoveItem(event, itemKey);
    }
  };

  onUpdateLineTotal = (index, lineTotal) => {
    if (this.props.onUpdateLineTotal) {
      this.props.onUpdateLineTotal(index, lineTotal);
    }
  };

  render() {
    const { screenSize } = this.context;

    if (!_.isEmpty(this.props.items)) {
      const renderPartAddButtons = () => {
        return (
          <div style={{ marginLeft: screenSize <= 575 ? 0 : 35 }}>
            <Button
              icon={<PlusCircleOutlined />}
              type="link"
              onClick={this.props.onAddItem}
            >
              Add Existing Part
            </Button>
            <Button
              icon={<PlusCircleOutlined />}
              type="link"
              onClick={() => {
                if (this.props.onAddNewPart) {
                  this.props.onAddNewPart();
                }
              }}
            >
              Add New Part
            </Button>
          </div>
        );
      };
      return (
        <Row gutter={[8, 8]}>
          <Col span={24}>
            {this.props.items.map((mapItem, index) => {
              return (
                <div key={mapItem.key}>
                  <WorkOrderLineItemPartsItem
                    displayIcon={index === 0}
                    key={mapItem.key}
                    part={mapItem}
                    shopParts={this.props.shopParts}
                    childRef={(ref) => (this.partsItemsRefs[index] = ref)}
                    onUpdateTotal={(lineTotal) =>
                      this.onUpdateLineTotal(index, lineTotal)
                    }
                    onRemoveItem={this.onRemoveItem}
                    onAddNewPart={this.props.onAddNewPart}
                    onUpdateLocalItem={(newVal, changedField) =>
                      this.props.onUpdateLocalItem(
                        mapItem.key,
                        newVal,
                        changedField
                      )
                    }
                    isDisabled={this.props.isDisabled}
                  />
                  {index === this.props.items.length - 1 &&
                    renderPartAddButtons()}
                </div>
              );
            })}
          </Col>
        </Row>
      );
    }
    return <></>;
  }
}

export default observer(WorkOrderLineItemParts);
